module.exports = __webpack_public_path__ + "media/images/home/main/albums-fffcfa5a5ae43d1f54200a02ad181a91.png";